import { z } from 'zod';
import { RedocSchemaObject, extendApi } from '../../openapi';

export const publicAccount = extendApi(
  z.object({
    id: extendApi(z.string(), {
      description: 'Account id',
      example: 'a1b2c3d4-e5f6-7a8b-9c0d-1e2f3a4b5c6d',
    }),
    name: extendApi(z.string(), {
      description: 'Name displayed in the Manager',
      example: 'My Company',
    }),
  }),
  {
    description: 'Account that the event belongs to',
    tags: ['account-model', 'account', 'model'],
  } as RedocSchemaObject,
);

export const publicAccountRef = extendApi(publicAccount, {
  $ref: '#/components/schemas/Account',
} as RedocSchemaObject);

export type PublicAccount = z.infer<typeof publicAccount>;
